import PropTypes from 'prop-types';
import React from 'react';

class FieldSet extends React.Component {
  render() {
    const { title, children, action } = this.props;

    return (
      <div>
        {
        title && (
          <div className="field-set">
            <h3>{ title }</h3>
            <hr className="field-set-line" />
            {action && <div className="ml-3 flex-shrink-0 align-self-center">{ action }</div>}
          </div>
        )}
        <div className="field-set-slot">
          { children }
        </div>
      </div>
    );
  }
}

FieldSet.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  action: PropTypes.node,
};

FieldSet.defaultProps = {
  children: null,
  action: null,
};

export default FieldSet;
